import React, { Component } from 'react';
import classes from './MainMenu.module.css';
import CategoryTabWrapper from '../CategoryTabWrapper/CategoryTabWrapper';

class MainMenu extends Component{
    componentDidMount() {
        this.props.resetFilter();
        window.scrollTo(0, 0);
        this.props.initPrice();
    }
    
    render() {
        
        let categoryItems = [[], [], [], []];
        this.props.categories.forEach(element => {
            const index = element.superID;
            categoryItems[index].push(element);
        });
        //console.log(this.props.categories);
        return(
            <div>
                <div className={classes.MenuGrid}>            
                    {this.props.superCategories.map((c, index) => (
                        <div className={classes.CategoryItem} key={c.id}>
                            <h2>
                                {c.name[0]}
                                {(c.hasOwnProperty('info') 
                                    ? <span>{c.info}</span>
                                    : null )} 
                            </h2>
                            {(c.hasOwnProperty('image') 
                                    ? <img src={c.image} alt="category description"/>
                                    : null )}
                            <div className={classes.CategoryWrapper} key={c.id}>   
                                <CategoryTabWrapper category={categoryItems[index]}/>
                            </div>
                        </div>
                    ))}
                </div>    
            </div>
        )
    }
}

export default MainMenu;
